// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"64f4dfe0","73":"2ded4c72","492":"d4a5d720","931":"3bfbc24e"}[chunkId] + ".chunk.js";
};